import type {
  AppSpecificDealPromptWISSPFilters,
  AudienceSpecificDealPromptWISSPFilters,
  BaseDealPromptWISSPFilters,
  DomainSpecificDealPromptWISSPFilters,
} from '@openx/types/dealPrompt.ts';

export const DOMAINS_DEFAULT_NUMBER_OF_RESULTS = 20_000;
export const BUNDLES_DEFAULT_NUMBER_OF_RESULTS = 2_000;
export const DEFAULT_MARKET_THRESHOLD = 7_000_000_000_000_000_000;
export const DEFAULT_DOMAINS_IMPRESSIONS_THRESHOLD = 100;
export const DEFAULT_BUNDLES_IMPRESSIONS_THRESHOLD = 100;
export const DEFAULT_DOMAINS_CPR_MARKET_REQUESTS_THRESHOLD = 10_000;
export const DEFAULT_BUNDLES_CPR_MARKET_REQUESTS_THRESHOLD = 10_000;

export const defaultBaseFilters: BaseDealPromptWISSPFilters = {
  performance: {
    minViewability: 0,
    minReach: 0,
    performanceData: [
      { filterColumn: 'cprmarketrequests', filterThreshold: 10000 },
      { filterColumn: 'impressions', filterThreshold: 100 },
    ],
  },
  noOfResult: 1_000_000,
  noOfDays: 30,
  cumulativeDataFilters: {
    performanceData: 'total_bidspendinusd',
    reachThreshold: 0,
    marketThreshold: DEFAULT_MARKET_THRESHOLD,
  },
};

export const defaultDomainSpecificFilters: DomainSpecificDealPromptWISSPFilters = {
  domainFilters: {
    geography: [],
    contentStyle: [],
    videoPlcmt: [],
    distributionChannel: [],
    deviceType: [],
    mediaSubtype: [],
    publisher: [],
    isDirect: null,
  },
  includeDomains: [],
  excludeDomains: [],
  vectorFilters: {
    safetyTier: [],
    contentStyle: [],
    iabCategory: [],
    tierDetails: { tier: 0, keys: [] },
    categoryThreshold: { iabCategoryScore: 0.75, safetyTierCompositeScore: 0, contentStyleScore: 0 },
  },
};

export const defaultAppSpecificFilters: AppSpecificDealPromptWISSPFilters = {
  appFilters: {
    subcategory: [],
    developer: [],
    contentRating: [],
    keywords: [],
    rating: null,
    ratingCount: 0,
    downloads: null,
    updateDate: null,
    languages: [],
    regions: [],
    marketSource: [],
    marketStatus: null,
    name: [],
    paid: null,
    origin: [],
    creator: [],
    category: [],
    platform: [],
    appInfoContentRating: [],
    coppa: null,
    deleted: null,
    modifiedDateTime: null,
  },
  tierDetails: { tier: 0, keys: [] },
  includeBundles: [],
  excludeBundles: [],
};

export const defaultAudienceSpecificFilters: AudienceSpecificDealPromptWISSPFilters = {
  audienceFilters: {
    age: [],
    gender: '',
    state: [],
    dma: [],
    congressionalDistrict: [],
    goal: [],
    segmentSearchMode: '',
    account: [],
    category: [],
    subCategory: [],
    country: [],
    region: '',
  },
};
